import type { App } from '@nab/x-types';
import type { AppLoaderConstructor } from '@nab/x-app-loaders';
import { getShellActions } from '@nab/x-registries';
import { runtimeEventBus } from '../services/runtimeEventBus';

/**
 * Extends an app loader to allow the runtime to tidy up event subscriptions when stopping an app
 * @param LoaderConstructor
 */
export function extendAppLoader<APP extends App = App>(LoaderConstructor: AppLoaderConstructor<APP>): AppLoaderConstructor<APP> {
    return class extends LoaderConstructor {
        public async unload(): Promise<any> {
            try {
                await getShellActions().dispatchEvent(
                    {
                        eventName: 'beforeAppUnload',
                        appId: 'SHELL'
                    },
                    {
                        instanceId: this.config.appConfig.instanceId,
                        appId: this.config.appMetaData.id
                    }
                );
                const result = await super.unload();
                return result;
            } finally {
                runtimeEventBus.unsubscribeInstance(this.config.appConfig.instanceId);
            }
        }
    };
}
